import { isOwnField } from '@cardstack/runtime-common';

import {
  isCardOrFieldDeclaration,
  type ModuleDeclaration,
} from '@cardstack/host/resources/module-contents';
import type { Type } from '@cardstack/host/services/card-type-service';

import type { BaseDef } from 'https://cardstack.com/base/card-api';

export function calculateTotalOwnFields(
  card: typeof BaseDef,
  cardType: Type,
): number {
  return cardType.fields.filter((field) => isOwnField(card, field.name)).length;
}

export function isSelectedItemIncompatibleWithSchemaEditor(
  selectedDeclaration: ModuleDeclaration | undefined,
): boolean {
  if (!selectedDeclaration) {
    return false;
  }
  return !isCardOrFieldDeclaration(selectedDeclaration);
}
